module.exports = __webpack_public_path__ + "static/media/5.b7935c66.jpg";